export var Spacing;
(function (Spacing) {
  Spacing["S0"] = "2px";
  Spacing["S1"] = "4px";
  Spacing["S2"] = "6px";
  Spacing["S3"] = "8px";
  Spacing["S4"] = "12px";
  Spacing["S5"] = "16px";
  Spacing["S6"] = "20px";
  Spacing["S7"] = "24px";
  Spacing["S8"] = "28px";
  Spacing["S9"] = "32px";
  Spacing["S10"] = "36px";
  Spacing["S11"] = "40px";
  Spacing["S12"] = "48px";
  Spacing["S13"] = "56px";
  Spacing["S14"] = "64px";
  Spacing["S15"] = "72px";
  Spacing["S16"] = "80px";
})(Spacing || (Spacing = {}));